import RecurrenceSwitch from './RecurrenceSwitch';

export default RecurrenceSwitch;
